export default {"src":"https://cloudflare.edhrec.com/_next/static/media/mana17.c299be14.svg","height":600,"width":600,"blurWidth":0,"blurHeight":0};